import NavbarTextil from "./NavbarTextil";

export default NavbarTextil;